<template>
    <div class="form-container">
        <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary);">Upload File</h2>
        <div class="form-section">
            <div class="form-group">
                <label>Action Name</label>
                <input type="text" placeholder="upload file" v-model="actionName" />
            </div>
            <div class="form-group">
                <label>Sheet Name</label>
                <select v-model="sheetName">
                    <option value="">Select Sheet</option>
                    <option v-for="sheet in worksheets" :key="sheet" :value="sheet">
                        {{ sheet }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label>File Name</label>
                <input type="text" placeholder="e.g. data_export.csv" v-model="fileName" />
            </div>
            <button class="button button-full" @click="addWorkflowItem">Add Workflow Item</button>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { addWorkflowItem as addWorkflowItemUtil, createUploadFileWorkflowItem } from '../utils/workflowUtils';
import { useWorksheetSelection } from '../composables/useWorksheetSelection';

// Use composable for worksheet selection
const { worksheets } = useWorksheetSelection();

const actionName = ref('');
const sheetName = ref('');
const fileName = ref('');

const addWorkflowItem = async () => {
    // Create the workflow item data
    const { keys, values } = createUploadFileWorkflowItem(
        actionName.value,
        sheetName.value,
        fileName.value
    );

    // Add to workflow sheet using utility
    await addWorkflowItemUtil(keys, values);
};
</script>
